import React, { CSSProperties } from "react";
import HeroSection from "../components/HeroSection";
import BottomSection from "../components/BottomSection";
import Cards from "../components/Cards";
import LogoWordmark from "../iamges/LogoWordmark.png";
import WhatWeProvide from "../components/WhatWeProvide";
import Header from "../components/Header";
import BenefitsSection from "../components/BenefitsSection";
import GetHomeOwnerApp from "../components/GetHomeOwnerApp";

export type Styles = {
  [key: string]: CSSProperties;
};

function Homeowner() {
  return (
    <div className='static'>
      <Header />
      <HeroSection />
      <Cards />
      <WhatWeProvide />
      <BenefitsSection />
      <GetHomeOwnerApp />

      <div>
        <img
          src={LogoWordmark}
          alt='LogoWordmark'
          className='logoWordmark'
          style={{ margin: "40px auto" }}
        />
      </div>

      <BottomSection />
      {/* <BottomSection /> */}
    </div>
  );
}

export default Homeowner;
